import React from 'react';
import { StyledButton } from '../style';
export var ContactUs = function () {
    return (React.createElement("a", { href: "/contactus", target: "_blank" },
        React.createElement(StyledButton, { type: "button" }, "Contact Us")));
};
//# sourceMappingURL=index.js.map